import { createSelector } from 'reselect'
import {
  getFilter
} from 'react-redux/selectors/app'

export default createSelector(
  [  getFilter ],
  (filter) => {
    return Object.assign(
      {},
      filter 
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/component/filter/selector.js